<template>
  <div id="app" ref="app">
    <!-- <Header v-if="(path === '/RetrieveName'  || path === '/Detail' || path === '/RetrieveInst' || path === '/RetrieveField' || path ==='/OrgHome' || path ==='/Overview' || path ==='/Analysis' || path ==='/Scholar' || path ==='/Trend' || path ==='/Keyword' || path === '/Periodical' )"> </Header> -->
    <Header
      v-if="(path !== '/LoginForClient' && path !== '/RetrieveFieldNew'  && path !== '/' && path.split('/')[1].toLowerCase() !== 'mobile') && isRouterAlive"
    ></Header>
    <mHeader v-if="path.split('/')[1].toLowerCase() === 'mobile'"></mHeader>
    <router-view v-if="isRouterAlive" />
    <mFooter v-if="path.split('/')[1].toLowerCase() === 'mobile'"></mFooter>
    <Footer v-if="(path !== '/LoginForClient'   && path.split('/')[1].toLowerCase() !== 'mobile')"></Footer>
  </div>
</template>

<script>
import mHeader from '@/mobile/common/Header'
import mFooter from '@/mobile/common/Footer'
import Header from '@/components/common/Header'
import SecondaryHeader from '@/components/common/SecondaryHeader'
import Footer from '@/components/common/Footer'
import { getUser } from '@/api/common'
import { login, exit } from '@/utils/index'

import { checkSSO } from '@/utils/checksso'
export default {
  name: 'App',
  components: {
    mHeader,
    mFooter,
    Header,
    SecondaryHeader,
    Footer
  },
  data () {
    return {
      path: this.$route.path,
      isRouterAlive: true
    }
  },
  beforeCreate () {
    // console.log(this)
    // if (this.$route.path == '/' || this.$route.path == '/Home') {
    // } else {
    //   if ((!localStorage.getItem('user') || !JSON.parse(localStorage.getItem('user')).No)) {
    //     login()
    //   }
    // }
  },
  created () {

  },
  mounted () {
    debugger
    let time = localStorage.getItem('time')
    let now = Date.now()
    if (now - time > 60480000) {
      localStorage.clear()
      localStorage.setItem('time', Date.now())
    }
    localStorage.removeItem('path')
    let isLogin
    let that = this
    if (this.path === '/LoginForClient') {
      return
    }
    // if(localStorage.getItem('user')){
    //   return
    // }
    let _this = this
    this.appCheck()
    // checkSSO('8tCZa6AcqjBmErNA').then(result => {
    //   var state = false
    //   console.log('result', result)
    //   if (result.code == '10000') {
    //     if (!localStorage.getItem('user')) {
    //       login()
    //       if (this.path === '/') {
    //         if (!isNaN(this.$route.query.kid)) {
    //           this.$router.push({ name: 'Detail', query: { kId: this.$route.query.kid } })
    //         }
    //       }
    //     }
    //     return
    //   }
    //   if (result.code != '10000') {
    //     localStorage.removeItem('user')
    //     if (this.path === '/') {
    //       if (!isNaN(this.$route.query.kid)) {
    //         this.$router.push({ name: 'Detail', query: { kId: this.$route.query.kid } })
    //       }
    //     } else {
    //       login()
    //     }
    //   }
    //   // isLogin = result.code == 10000?true:false;
    //   // if (localStorage.getItem('user')) {
    //   //   // let data = {
    //   //   //   otid: JSON.parse(localStorage.getItem('user')).tid
    //   //   // }
    //   //   if (res.status && isLogin) {
    //   //   } else if (res.status === 0 && !isLogin) {
    //   //     localStorage.removeItem('user')
    //   //     that.reload()
    //   //   } else if (res.status === 0 && isLogin) {
    //   //     localStorage.removeItem('user')
    //   //     login()
    //   //   } else if (res.status && !isLogin) {
    //   //     exit()
    //   //     that.reload()
    //   //   }
    //   //   // getUser(data).then(res => {
    //   // if (res.status && isLogin) {
    //   // } else if (res.status === 0 && !isLogin) {
    //   //   localStorage.removeItem('user')
    //   //   that.reload()
    //   // } else if (res.status === 0 && isLogin) {
    //   //   localStorage.removeItem('user')
    //   //   login()
    //   // } else if (res.status && !isLogin) {
    //   //   exit()
    //   //   that.reload()
    //   // }
    //   //   // })
    //   // } else {
    //   //   if (isLogin) {
    //   //     login()
    //   //   }
    //   // }
    // })
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    appCheck () {
      checkSSO('8tCZa6AcqjBmErNA').then(result => {
        var state = false
        console.log('result', result)
        if (result.code == '10000') {
          if (this.path === '/') {
          } else {
            if (!localStorage.getItem('user')) {
              login()
            }
          }
        }
        if (result.code != '10000') {
          localStorage.removeItem('user')
          if (this.path === '/') {
          } else {
            login()
          }
        }
      })
    }
  },
  watch: {
    $route (to, from) {
      this.path = to.path
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue